import { useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import Login from "./components/Login.jsx";
import Dashboard from "./components/Dashboard.jsx";

function App() {
  const [token, setTokenState] = useState(localStorage.getItem("token"));

  const setToken = newToken => {
    if (newToken) {
      localStorage.setItem("token", newToken);
    } else {
      localStorage.removeItem("token");
    }
    setTokenState(newToken);
  };

  if(!token){
    return (
      <>
        <Login setToken={setToken} />
        <Analytics />
      </>
    );
  }

  return (
    <>
      <Dashboard token={token} setToken={setToken} />
      <Analytics />
    </>
  );
}

export default App;
